/* eslint-disable */

import type { Config } from "@wagmi/core"
import type { Address } from "viem"
import { multicall } from "@wagmi/core"
import { formatUnits, isAddressEqual } from "viem"

import { equalensAbi26 } from "@/domains/abis"
import { BIGINT_ZERO } from "../constants"
import { EqualensVeNftVote, MulticallContractConfig } from "../types"

type EqualensVeNftVotesProps = {
  chainId: number
  config: Config
  equalens26: Address
  nftIds: Array<number>
}

type LensResult = { result: [Array<Address>, Array<bigint>]; status: "success" | "failure"; error?: Error }

export const equalensMultiVeNftVotes = async ({ chainId, config, equalens26, nftIds }: EqualensVeNftVotesProps) => {
  try {
    if (!chainId || !config || !equalens26 || !nftIds || nftIds.length === 0) return

    const contracts: Array<MulticallContractConfig> = []
    for (const nftId of nftIds) {
      contracts.push({
        address: equalens26,
        abi: equalensAbi26,
        functionName: "getPoolsVotedByNft",
        args: [nftId],
        chainId,
      })
    }

    // @ts-ignore
    const lenses = await multicall(config, { contracts })

    let votes: Array<EqualensVeNftVote> = lenses
      .map((lens: any) => {
        if (!lens.result[0] || !lens.result[1]) return []
        return lens.result[0].map((address: Address, index: number) => ({
          address,
          balance: Number(formatUnits(lens.result[1][index] ?? BIGINT_ZERO, 18)),
          votePercent: 0,
        }))
      })
      .flat()

    // it's highly possible that we have multiple votes on the same pool, so merge them together
    votes = votes.reduce((acc, curr) => {
      const existingVote = acc.find((vote: EqualensVeNftVote) => isAddressEqual(vote.address, curr.address))
      if (existingVote) {
        existingVote.balance += curr.balance
      } else {
        acc.push(curr)
      }
      return acc
    }, [] as Array<EqualensVeNftVote>)

    const totalVotes = votes.reduce((acc, curr) => acc + curr.balance, 0)

    // console.log("totalVotes", totalVotes)

    // now we add in their vote percentages
    votes = votes.map((vote: any) => ({
      ...vote,
      votePercent: Math.ceil(Number((vote.balance / totalVotes) * 100)),
    }))

    const hasVote = (vote: any) => vote?.votePercent > 0
    votes = votes.filter(hasVote).sort((a, b) => b.votePercent - a.votePercent)

    const filteredVoteTotal = votes.reduce((current, acc) => current + acc.votePercent, 0)
    if (filteredVoteTotal !== 100 && votes && votes.length > 0) {
      // @ts-ignore
      votes[0].votePercent += 100 - filteredVoteTotal
    }
    return votes
  } catch (error: any) {
    console.error("equalensMultiVeNftVotes", error)
  }

  return []
}
